/* ==========================================================================
   main.js — global site behavior: header, mobile nav, reveal animations,
   quantity steppers, tabs, toasts, newsletter/contact form stubs.
   No build step / no dependencies — plain DOM APIs only.
   ========================================================================== */
(function () {
  "use strict";

  /* ---------- Sticky header shadow on scroll ---------- */
  var header = document.querySelector("[data-site-header]");
  function onScroll() {
    if (!header) return;
    if (window.scrollY > 8) header.classList.add("is-scrolled");
    else header.classList.remove("is-scrolled");
  }
  document.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile nav drawer ---------- */
  var mobileNav = document.querySelector("[data-mobile-nav]");
  document.querySelectorAll("[data-mobile-nav-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (mobileNav) {
        mobileNav.classList.add("is-open");
        document.body.style.overflow = "hidden";
      }
    });
  });
  document.querySelectorAll("[data-mobile-nav-close]").forEach(function (btn) {
    btn.addEventListener("click", closeMobileNav);
  });
  function closeMobileNav() {
    if (mobileNav) {
      mobileNav.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  }
  document.querySelectorAll("[data-mobile-sub-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var sub = document.getElementById(btn.getAttribute("data-mobile-sub-toggle"));
      if (!sub) return;
      var open = sub.style.display === "flex";
      sub.style.display = open ? "none" : "flex";
      btn.classList.toggle("is-open", !open);
    });
  });

  /* ---------- Reveal-on-scroll ---------- */
  var revealEls = document.querySelectorAll(".reveal, .reveal-stagger");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- Generic quantity steppers ---------- */
  function clamp(val, min, max) {
    if (isNaN(val)) return min;
    return Math.max(min, max ? Math.min(max, val) : val);
  }
  document.addEventListener("click", function (e) {
    var stepBtn = e.target.closest("[data-step]");
    if (!stepBtn) return;
    var wrap = stepBtn.closest("[data-qty-stepper]");
    if (!wrap) return;
    var input = wrap.querySelector("[data-qty-input]");
    if (!input) return;
    var min = parseInt(input.getAttribute("min") || "1", 10);
    var max = input.getAttribute("max") ? parseInt(input.getAttribute("max"), 10) : null;
    var step = parseInt(stepBtn.getAttribute("data-step"), 10);
    var next = clamp((parseInt(input.value, 10) || min) + step, min, max);
    input.value = next;
    input.dispatchEvent(new CustomEvent("qtychange", { bubbles: true, detail: { value: next, wrap: wrap } }));
  });
  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-qty-input]");
    if (!input) return;
    var min = parseInt(input.getAttribute("min") || "1", 10);
    var max = input.getAttribute("max") ? parseInt(input.getAttribute("max"), 10) : null;
    var val = clamp(parseInt(input.value, 10), min, max);
    input.value = val;
    input.dispatchEvent(new CustomEvent("qtychange", { bubbles: true, detail: { value: val, wrap: input.closest("[data-qty-stepper]") } }));
  });

  /* ---------- Tabs (product info) ---------- */
  document.querySelectorAll("[data-tabs]").forEach(function (tabsEl) {
    var btns = tabsEl.querySelectorAll(".tabs__btn");
    var panels = tabsEl.querySelectorAll(".tabs__panel");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var target = btn.getAttribute("data-tab-target");
        btns.forEach(function (b) { b.classList.toggle("is-active", b === btn); });
        panels.forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-tab-panel") === target); });
      });
    });
  });

  /* ---------- Accordion (FAQ etc.) ---------- */
  document.querySelectorAll(".accordion-trigger").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var item = trigger.closest(".accordion-item");
      var panel = item.querySelector(".accordion-panel");
      var isOpen = item.classList.contains("is-open");
      var group = item.closest("[data-accordion-group]");

      if (group && group.hasAttribute("data-accordion-single")) {
        group.querySelectorAll(".accordion-item.is-open").forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove("is-open");
            openItem.querySelector(".accordion-panel").style.maxHeight = null;
          }
        });
      }

      item.classList.toggle("is-open", !isOpen);
      panel.style.maxHeight = !isOpen ? panel.scrollHeight + "px" : null;
    });
  });

  /* ---------- Toast ---------- */
  var toastEl = document.querySelector("[data-toast]");
  var toastTimer = null;
  window.showToast = function (message) {
    if (!toastEl) return;
    toastEl.querySelector("[data-toast-text]").textContent = message;
    toastEl.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("is-visible"); }, 2600);
  };

  /* ---------- Newsletter + contact forms (front-end stub) ---------- */
  document.querySelectorAll("[data-newsletter-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var success = form.querySelector("[data-form-success]");
      var email = form.querySelector("input[type=email]");
      if (email && !email.value) return;
      form.reset();
      if (success) success.classList.add("is-visible");
      window.showToast && window.showToast("🎉 Welcome to the Apykidz family!");
    });
  });

  document.querySelectorAll("[data-contact-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var success = form.querySelector("[data-form-success]");
      form.reset();
      if (success) success.classList.add("is-visible");
    });
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var WISHLIST_KEY = "apykidz_wishlist";
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function refreshWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var id = btn.getAttribute("data-wishlist-toggle");
      btn.classList.toggle("active", list.indexOf(id) !== -1);
    });
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    var id = btn.getAttribute("data-wishlist-toggle");
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
      window.showToast && window.showToast("💗 Added to wishlist");
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    refreshWishlistButtons();
  });
  refreshWishlistButtons();

  /* ---------- Footer year ---------- */
  document.querySelectorAll("[data-current-year]").forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });
})();
